"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Grid = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Grid = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    (0, _classCallCheck2.default)(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          alignContent = _this$props.alignContent,
          alignItems = _this$props.alignItems,
          children = _this$props.children,
          container = _this$props.container,
          direction = _this$props.direction,
          id = _this$props.id,
          item = _this$props.item,
          justify = _this$props.justify,
          lg = _this$props.lg,
          md = _this$props.md,
          sm = _this$props.sm,
          spacing = _this$props.spacing,
          wrap = _this$props.wrap,
          xl = _this$props.xl,
          xs = _this$props.xs,
          zeroMinWidth = _this$props.zeroMinWidth,
          className = _this$props.className,
          classes = _this$props.classes,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["alignContent", "alignItems", "children", "container", "direction", "id", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth", "className", "classes"]);
      return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({
        alignContent: alignContent,
        alignItems: alignItems,
        container: container,
        direction: direction,
        id: id,
        className: (0, _classnames.default)("prmbl-grid", className, classes.root),
        item: item,
        justify: justify,
        lg: lg,
        md: md,
        sm: sm,
        spacing: spacing,
        wrap: wrap,
        xl: xl,
        xs: xs,
        zeroMinWidth: zeroMinWidth
      }, otherProps), children);
    });
    return _this;
  }

  return Grid;
}(_react.Component);

exports.Grid = Grid;
(0, _defineProperty2.default)(Grid, "propTypes", {
  /**
   * Defines the align content style property. It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(["stretch", "center", "flex-start", "flex-end", "space-between", "space-around"]),

  /**
   * Defines the align items style property. It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "stretch", "baseline"]),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * If `true`, the component will have the flex container behavior. You should be wrapping `items` with a container.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property. It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(["row", "row-reverse", "column", "column-reverse"]),

  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component will have the flex `item` behavior. You should be wrapping `items` with a `container`.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property. It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around"]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the `lg` breakpoint and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  lg: _propTypes.default.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the `md` breakpoint and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  md: _propTypes.default.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the `sm` breakpoing and wider screens if not overridden.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  sm: _propTypes.default.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component. It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),

  /**
   * Defines the `flex-wrap` style property. It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(["nowrap", "wrap", "wrap-reverse"]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the `xl` breakpoint and wider screens.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  xl: _propTypes.default.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for all the screen sizes with the lowest priority.
   * Grid always has a size of 12, so using value 6 means the grid item will take up half the space. Allowing for another size 6 grid item to be alongside it.
   */
  xs: _propTypes.default.oneOf([false, "auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   */
  zeroMinWidth: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * HTML Role
   */
  role: _propTypes.default.string,

  /**
   * The component or element to render for the grid
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
});
(0, _defineProperty2.default)(Grid, "defaultProps", {
  className: "",
  classes: {}
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Grid);

exports.default = _default;